'use client'

import UserDataForm from '@/app/ui/user/user-data-form'
import UserEventsTable from '@/app/ui/user/user-events-table'
import { useAuth } from '@/context/AuthContext'
import { Spinner } from '@nextui-org/spinner'
import { auth } from '@/firebase'
import Link from 'next/link'
import { sendPasswordResetEmail } from 'firebase/auth'
import { useState } from 'react'
import PartnerDataForm from '@/app/ui/user/partner/partner-data-form'
import AssociationIdChanger from '@/app/ui/user/admin/association-id-changer'
import UserFavouritesTable from '@/app/ui/user/user-favourites-table'

export default function Page() {
    const [checking, setChecking] = useState(false)
    const { user, logout } = useAuth()

    const handleLogout = async () => {
        await logout()
        window.location.href = '/access'
    }

    const handlePwdChange = async () => {
        if (user != null) {
            setChecking(true)
            sendPasswordResetEmail(auth, user.email)
                .then(() => {
                    alert(
                        "E' stata inviata una mail per il cambio della password all'indirizzo '" +
                            user.email +
                            "'"
                    )
                    setChecking(false)
                })
                .catch((error) => {
                    alert(error)
                    setChecking(false)
                })
        }
    }

    return (
        <div className="mb-10 mt-4 flex w-full justify-center px-4 md:place-items-center">
            {user === null ||
                (user === undefined && (
                    <div className="mt-10 flex justify-center">
                        <Spinner color="primary" />
                    </div>
                ))}
            {user != null && user != undefined && (
                <div className="grid w-full grid-cols-1 gap-4 md:w-3/5 lg:w-[630px]">
                    {user != null && user.type === 'user' && (
                        <>
                            <UserDataForm user={user} />
                            <UserEventsTable events={user.events} />
                            <UserFavouritesTable games={user.preferedGames} />
                            <div className="mt-4 w-full text-sm text-black md:w-3/5 lg:w-[630px]">
                                <p>Disclaimer:</p>
                                <p className="italic">
                                    Il tuo account e i dati inseriti per le
                                    prenotazioni di sessioni ed eventi verranno
                                    cancellati dopo 10/15 giorni dal termine del
                                    ToPlay.{' '}
                                </p>
                                <p className="italic">
                                    Al termine della manifestazione nessuna
                                    informazione rimarrà sulla banca dati
                                    dell'associazione "Il Fortuna Dado". I dati
                                    raccolti verranno utilizzati solo durante i
                                    giorni del festival "ToPlay" e in alcun modo
                                    verranno rilasciati a terzi.{' '}
                                </p>
                            </div>
                        </>
                    )}

                    {user != null && user.type === 'partner' && (
                        <>
                            <div className="grid w-fit grid-cols-1 justify-self-center">
                                <p className="text-center text-2xl font-bold">
                                    Azioni disponibili
                                </p>
                                <div className="spacer-yellow" />
                            </div>
                            <div className="grid w-full grid-cols-1 items-center justify-center justify-items-center gap-4">
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/games"
                                >
                                    <i className="bi-dice-5 left-4 ml-4 text-2xl" />
                                    <p className="mr-4">
                                        GESTISCI I TUOI GIOCHI
                                    </p>
                                </Link>
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/events"
                                >
                                    <i className="bi-people left-4 ml-4 text-2xl" />
                                    <p className="mr-4">
                                        GESTISCI I TUOI EVENTI
                                    </p>
                                </Link>
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/events/guests"
                                >
                                    <i className="bi-calendar-event left-4 ml-4 text-2xl" />
                                    <p className="mr-4">ISCRIZIONI AGLI EVENTI</p>
                                </Link>
                            </div>
                            <PartnerDataForm user={user} />
                        </>
                    )}

                    {user != null && user.type === 'admin' && (
                        <>
                            <div className="grid w-fit grid-cols-1 justify-self-center">
                                <p className="text-center text-2xl font-bold">
                                    Azioni disponibili
                                </p>
                                <div className="spacer-yellow" />
                            </div>
                            <div className="grid w-full grid-cols-1 items-center justify-center justify-items-center gap-4 justify-self-center lg:w-[800px] lg:grid-cols-2">
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/games"
                                >
                                    <i className="bi-dice-5 left-4 ml-4 text-2xl" />
                                    <p className="mr-4">GIOCHI ASSOCIAZIONE</p>
                                </Link>
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/events"
                                >
                                    <i className="bi-people left-4 ml-4 text-2xl" />
                                    <p className="mr-4">EVENTI ASSOCIAZIONE</p>
                                </Link>
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/accounts"
                                >
                                    <i className="bi-person-add left-4 ml-4 text-2xl" />
                                    <p className="mr-4">GESTISCI UTENTI</p>
                                </Link>
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/events/guests"
                                >
                                    <i className="bi-calendar-event left-4 ml-4 text-2xl" />
                                    <p className="mr-4">ISCRIZIONI AGLI EVENTI</p>
                                </Link>
                            </div>
                            <div className='flex justify-center justify-self-center w-2/3'>
                                <Link
                                    className="mobile-button-black-border flex items-center justify-between"
                                    href="/profile/analytics"
                                >
                                    <i className="bi-bar-chart-line left-4 ml-4 text-2xl" />
                                    <p className="mr-4">STATISTICHE</p>
                                </Link>
                            </div>
                            <AssociationIdChanger user={user} />
                            <PartnerDataForm user={user} />
                            <UserEventsTable events={user.events} />
                            <UserFavouritesTable games={user.preferedGames} />
                        </>
                    )}

                    <div className="flex w-full justify-center justify-self-center lg:w-96">
                        <button
                            className="mobile-button-red flex items-center justify-between"
                            onClick={handleLogout}
                        >
                            <i className="bi-door-open-fill left-4 ml-4 text-2xl" />
                            <p className="mr-4">ESEGUI IL LOGOUT</p>
                        </button>
                    </div>

                    <div className="flex justify-center py-4">
                        <button onClick={handlePwdChange}>
                            <div className="text-lg italic text-gray-500">
                                {checking ? (
                                    <Spinner color="default" />
                                ) : (
                                    <div className="flex items-center">
                                        <i className="bi-lock-fill mx-2 text-2xl"></i>
                                        <p>Cambia password</p>
                                    </div>
                                )}
                            </div>
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
